import { faEdit } from '~components/icon';
import { Column } from '~components/table-view-v3';
import { linkCellRender } from '~components/table-view-v3/columnRenderers';

const columnsFactory = (toggleClientServicesModal: (id: number) => void) => {
  const columns: Column[] = [
    {
      id: 'client',
      header: 'Client',
      type: 'text',
      deriveValue: (row) => row?.client?.full_name || '',
      renderReadOnly: linkCellRender((row) => toggleClientServicesModal(row.client_id), faEdit),
    },
    {
      id: 'count',
      header: 'No. of Services',
      type: 'text',
    },
  ];

  return columns;
};

export default columnsFactory;
